// frontend/src/components/layout/NotificationDropdown.jsx

import { useTranslation } from 'react-i18next';
import { useNotifications } from '../../contexts/NotificationContext';
import { useTabs } from '../../tabs/useTabs';
import { ICON, CaretRight, ClipboardText, ShieldCheck, Truck } from '../../icons';
import './NotificationDropdown.css';

// What needs the merchant's attention, as cards that open the screen dealing
// with it. Shared by the desktop bell's dropdown and the phone's notifications
// sheet; `onDone` runs after a card has opened its screen.
export function NotificationList({ onDone }) {
  const { openTab } = useTabs();
  const { t } = useTranslation();
  const {
    hasNotifications,
    hasHealthIssues,
    healthIssueCount,
    hasPOsDueToday,
    posDueTodayCount,
    hasOutstandingDeliveries,
    outstandingDeliveriesCount,
  } = useNotifications();

  // Tab opener (focus-or-create), not raw navigate() — navigate to a path
  // already in the URL bar is a no-op and would open nothing.
  const handleNavigate = (path) => {
    openTab(path);
    onDone();
  };

  return !hasNotifications ? (
    <div className="notification-dropdown-empty">
      <p>{t('notifications.allClear')}</p>
    </div>
  ) : (
    <div className="notification-dropdown-cards">
      {hasOutstandingDeliveries && (
        <button
          className="notification-card"
          onClick={() => handleNavigate('/purchase-orders')}
        >
          <div className="notification-card-icon outstanding">
            <Truck size={ICON.xl} />
          </div>
          <div className="notification-card-body">
            <p className="notification-card-title">{t('notifications.outstandingTitle')}</p>
            <p className="notification-card-desc">
              {t('notifications.outstandingDesc', { count: outstandingDeliveriesCount })}
            </p>
          </div>
          <CaretRight className="notification-card-chevron" size={ICON.xl} />
        </button>
      )}

      {hasPOsDueToday && (
        <button
          className="notification-card"
          onClick={() => handleNavigate('/purchase-recommendations')}
        >
          <div className="notification-card-icon po">
            <ClipboardText size={ICON.xl} />
          </div>
          <div className="notification-card-body">
            <p className="notification-card-title">{t('notifications.poTitle')}</p>
            <p className="notification-card-desc">
              {t('notifications.poDesc', { count: posDueTodayCount })}
            </p>
          </div>
          <CaretRight className="notification-card-chevron" size={ICON.xl} />
        </button>
      )}

      {hasHealthIssues && (
        <button
          className="notification-card"
          onClick={() => handleNavigate('/data-health')}
        >
          <div className="notification-card-icon health">
            <ShieldCheck size={ICON.xl} />
          </div>
          <div className="notification-card-body">
            <p className="notification-card-title">{t('notifications.healthTitle')}</p>
            <p className="notification-card-desc">
              {t('notifications.healthDesc', { count: healthIssueCount })}
            </p>
          </div>
          <CaretRight className="notification-card-chevron" size={ICON.xl} />
        </button>
      )}
    </div>
  );
}

const NotificationDropdown = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="dropdown">
      <div className="dropdown-panel notification-dropdown-panel">
        <NotificationList onDone={onClose} />
      </div>
    </div>
  );
};

export default NotificationDropdown;
